module.exports = __webpack_public_path__ + "img/apcs1.ad96de72.png";